/**
 * Avviso sui portieri di un insieme di giocatori: nessuno, oppure piu di uno.
 * Solo un avviso: il secondo portiere puo giocare in campo, e dopo un rosso al
 * portiere in porta va chi c'e. Lo usano la formazione e il Live Timer.
 */

import type { RuoloGiocatore } from '@calcio/shared';

export function avvisoPortieri(ruoli: readonly RuoloGiocatore[], dove: string): string | null {
  const portieri = ruoli.filter((r) => r === 'portiere').length;
  if (portieri === 0) return `Nessun portiere ${dove}`;
  if (portieri > 1) return `${portieri} portieri ${dove}`;
  return null;
}
